import PropTypes from 'prop-types'

const CalendarOverlay = ({ show, onClick }) => (
  <div className={`CalendarOverlay${show ? ' is-shown' : ''}`} onClick={onClick}></div>
)

export default CalendarOverlay

CalendarOverlay.propTypes = { show: PropTypes.bool, onClick: PropTypes.func }
